import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';

import {check} from 'react-icons-kit/fa/check'
import { close } from 'react-icons-kit/fa/close';
import { print } from 'react-icons-kit/fa/print';
import { phenotypes } from '../../../assets/icons/phenotypes';
import {antibodies} from '../../../assets/icons/antibodies';
import {drops} from 'react-icons-kit/metrize/drops';
import {clipboard} from 'react-icons-kit/icomoon/clipboard'

import FlatButton from '../../../components/FlatButton';
import SelectFormatPrint from '../modals/SelectFormatPrint';

import { healthFacilitiesGetCriterial } from '../../../libs/services';
import { pencilSquareO } from 'react-icons-kit/fa/pencilSquareO';
import { envelop } from 'react-icons-kit/icomoon/envelop';
import { timesCircleO } from 'react-icons-kit/fa/timesCircleO';


class Laboratory extends Component{
    constructor(props){
        super(props);

        this.onPrintLab = this.onPrintLab.bind(this);
        this.openFileTypeSections = this.openFileTypeSections.bind(this);
        this.noAction = this.noAction.bind(this);

        this.state = {
            lab_select_doc:{}
        }
    }

    async componentDidMount(){
        this.props.onRef(this);

        var hf_id = sessionStorage.getItem('health_facilities_id');
        var response = await healthFacilitiesGetCriterial(hf_id, 'LAB_SELECT_DOC');
        if(response){
            this.setState({ lab_select_doc: response });
        }
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    async onPrintLab(e, variables){
        var hf_id = sessionStorage.getItem('health_facilities_id');

        await this.props.waiting.handleShow('Imprimiento...');
        
        var obj = {
            health_facilities_id: hf_id,
            id: variables.id,
            file_type: variables.file_type,
            nEtiqueta:[]
        }

        if(this.state.lab_select_doc.value !== 'NO'){
            obj.option = 'filter';
        }

        if(variables.printing === 'sections'){
            obj.ids = variables.ids;
        }

        var response = await this.props.getDocumentType(obj.file_type);

        if(response !== undefined){						
            if(response.print_type === 'template'){
                await this.props.printDocumentTemplate(obj, response.print_automatically);
            }else if(response.print_type === 'external'){
                await this.props.printDocumentExternal(obj, response.print_automatically);
            }
        }
         
        await this.props.waiting.handleClose();
        
    }

    openFileTypeSections(){
        this.select_format.openModal();
    }

    noAction(e){
        e.preventDefault();
    }

    render(){
        const {t}  = this.props;
        return(
            <div className='col-xs-12 form-group center'>
                {/* <FlatButton 
                    fill="no-data"
                    size="lg"
                    disabled
                    icon={phenotypes}
                    title={t('content.generics.buttons.phenotypes')}
                    text={t('content.generics.buttons.phenotypes')}
                    action={this.noAction}
                /> */}

                {/* <FlatButton 
                    fill="no-data"
                    size="lg"
                    disabled
                    icon={antibodies}
                    title={t('content.generics.buttons.antibodies')}
                    text={t('content.generics.buttons.antibodies')}
                    action={this.noAction}
                /> */}

                {/* <FlatButton 
                    fill="no-data"
                    size="lg"
                    disabled
                    icon={drops}
                    title={t('content.generics.buttons.components')}
                    text={t('content.generics.buttons.components')}
                    action={this.noAction}
                /> */}

                {/* <FlatButton 
                    fill="no-data"
                    size="lg"
                    disabled
                    icon={clipboard}
                    title={t('content.generics.buttons.offers')}
                    text={t('content.generics.buttons.offers')}
                    action={this.noAction}
                /> */}

                {/* <FlatButton 
                    fill="no-data"
                    size="lg"
                    disabled
                    icon={pencilSquareO}
                    title={t('content.generics.buttons.notes')}
                    text={t('content.generics.buttons.notes')}
                    action={this.noAction}
                /> */}

                <FlatButton 
                    fill="default"
                    size="lg"
                    icon={check}
                    title={t('content.generics.buttons.validation')}
                    text={t('content.generics.buttons.validation')}
                    action={this.props.onValidate}
                    variables={this.props.validate}
                />
                <FlatButton 
                    fill="default"
                    size="lg"
                    icon={close}
                    title={t('content.generics.buttons.validation')}
                    text={t('content.generics.buttons.validation')}
                    action={this.props.openModalSections}
                    variables={this.props.validate}
                />
                
                <FlatButton 
                    fill="default"
                    size="lg"
                    icon={print}
                    title="Imprimir"
                    text="Imprimir"
                    action={
                        this.state.lab_select_doc.value === 'NO' ? this.onPrintLab : this.openFileTypeSections
                    }
                    variables={{
                        id:this.props.variables.id,
                        printing:this.state.lab_select_doc.value === 'NO' ? 'direct' : 'sections',
                        file_type: this.state.lab_select_doc.value === 'NO' ? this.props.variables.print_key : this.props.variables.confirm_key,
                    }}
                />

                {/* <FlatButton 
                    fill="no-data"
                    size="lg"
                    disabled
                    icon={envelop}
                    title="Enviar Resultados"
                    text="Enviar Resultados"
                    action={this.noAction}
                /> */}

                {/* <FlatButton 
                    fill="no-data"
                    size="lg"
                    disabled
                    icon={timesCircleO}
                    title="Rechazar"
                    text="Rechazar"
                    action={this.noAction}
                /> */}

                <SelectFormatPrint 
                    {...this.props} 
                    sections={this.props.sections} 
                    onPrintLab={this.onPrintLab}
                    id={this.props.variables.id}
                    onRef={ref => this.select_format = ref} 
                />
            </div>
        )
    }
}

export default translate('translations') (Laboratory);